module.exports = " <div class=card _v-64fcbff8=\"\"> <img class=wordTop src=" + require("../assets/card_word_1.png") + " _v-64fcbff8=\"\"> <img class=wordCenter src=" + require("../assets/card_word_2.png") + " _v-64fcbff8=\"\"> <img src=" + require("../assets/btn_yq.png") + " alt=邀请好友点赞 class=btn @click=getNum _v-64fcbff8=\"\"> <div class=share v-show=display @click=hide _v-64fcbff8=\"\"> <img src=" + require("../assets/share.png") + " _v-64fcbff8=\"\"> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-64fcbff8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Card.vue
// module id = 102
// module chunks = 1